import React, { useState, useEffect } from "react";

// components
import { Button, FormGroup, Input, Row, Col, Spinner, Label, Collapse, Form, InputGroup, InputGroupAddon, InputGroupText } from "reactstrap";
import Select from 'react-select'

// utils
import { showMessage } from "utils/message.js";
import { formateCurrencyInput } from "utils/formats";

// api
import usuario_api from "api/usuario_api.js";
import dadosimplantacaotim_api from 'api/dadosimplantacaotim_api';
import indicesextras_api from "api/indicesextras_api";

export default function CentroCustos({ history }) {

    const [showLoading, setshowLoading] = useState(false);

    const [isDisable, set_isDisable] = useState(true);

    // Grupos Econômicos
    const [options_gruposeconomicos, set_options_gruposeconomicos] = useState([]);
    const loadOptionsGruposEconomicos = () => {
        dadosimplantacaotim_api.getGruposEconomicos(null).then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                let _gruposeconomicos = [];
                result.data.map((m) => _gruposeconomicos.push({ label: m, value: m }));
                set_options_gruposeconomicos(_gruposeconomicos);
            }
        })
    }
    const [grupoeconomico, set_grupoeconomico] = useState(null);
    const handleChangeGrupoEconomico = (value) => {
        set_indicesExtras([]);
        set_grupoeconomico(value.value);
        loadOptionsIndicesExtras(value.value);
    }

    const [indicesExtras, set_indicesExtras] = useState([]);
    const loadOptionsIndicesExtras = (_grupoeconomico) => {
        setshowLoading(true);
        indicesextras_api.get(_grupoeconomico).then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                set_indicesExtras(result.data);
            }
        })
    }

    const onBlurInput = (tbDadosImplantacaoTim_Id, name, value) => {
        let indices = [];
        indicesExtras.map(m => {
            if (m.tbDadosImplantacaoTim_Id == tbDadosImplantacaoTim_Id)
                m = {...m, [name]: value};            
            indices.push(m);
        });        
        set_indicesExtras(indices);
    }
    
    useEffect(() => {
        usuario_api.getFuncionalidadeAcaoLiberada("IndicesExtras", "Editar").then((result) => { set_isDisable(!result); });

        loadOptionsGruposEconomicos();
    }, []);    

    const handleClickSalvar = () => {
        let json_submit = indicesExtras;

        setshowLoading(true);
        indicesextras_api.post(json_submit).then(result => handleReturnSalvar(result));
    }

    const handleReturnSalvar = (result) => {
        setshowLoading(false);
        if (result.status !== 200) {
            showMessage("Aviso", result.message, 'error', null);
        }
        else {
            set_grupoeconomico(null);
            set_indicesExtras([]);
            showMessage("Aviso", "Operação executada com sucesso!", 'success', null);
        }
    }

    return (
        <>
            {showLoading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <Spinner></Spinner>
                    </div>
                </div>
            }
            <div className="content">
                <Row className="mb-4">
                    <Col lg="4" md="6" sm="12">
                        <FormGroup>
                            <label className="form-control-label">Grupo Econômico</label>
                            <Select
                                name="grupoeconomico"
                                options={options_gruposeconomicos}
                                getOptionLabel={o => o.label}
                                getOptionValue={o => o.value}
                                value={options_gruposeconomicos.filter(f => f.value == grupoeconomico)}
                                onChange={(o) => handleChangeGrupoEconomico(o)}
                                classNamePrefix="select"
                                placeholder="[ Selecione ]"
                            />
                        </FormGroup>
                    </Col>
                </Row>
                {grupoeconomico &&
                    <>
                        {indicesExtras.map(m => (
                            <Row className="align-items-center">
                                <Col lg="6" md="12" sm="12">
                                    <strong>{m.custCode + " - " + m.nickName}</strong>
                                </Col>
                                <Col lg="3" md="6" sm="6">
                                    <FormGroup>
                                        <label className="form-control-label">Percentual ISS</label>
                                        <Input className={"form-control text-md-right"} step={0.01} disabled={isDisable} 
                                                autocomplete="off" type="number" name="percentualISS" defaultValue={formateCurrencyInput(m.percentualISS)} 
                                                onBlur={(e) => onBlurInput(m.tbDadosImplantacaoTim_Id, "percentualISS", e.target.value)} />
                                    </FormGroup>
                                </Col>
                                <Col lg="3" md="6" sm="6">
                                    <FormGroup>
                                        <label className="form-control-label">Percentual Margem Seguro</label>
                                        <Input className={"form-control text-md-right"} step={0.01} disabled={isDisable} 
                                                autocomplete="off" type="number" name="percentualMargemSeguro" defaultValue={formateCurrencyInput(m.percentualMargemSeguro)}
                                                onBlur={(e) => onBlurInput(m.tbDadosImplantacaoTim_Id, "percentualMargemSeguro", e.target.value)} />
                                    </FormGroup>
                                </Col>
                            </Row>
                        ))
                        }
                        {!isDisable && 
                            <Row>
                                <Col lg="12" md="12" sm="12" className="text-center">
                                    <Button color="success" onClick={handleClickSalvar}><i className="fas fa-save"></i>  Salvar</Button>
                                </Col>
                            </Row>
                        }
                    </>
                }
            </div>
        </>

    );
}